import { render, staticRenderFns } from "./processAccidentReport.vue?vue&type=template&id=3d81b421"
import script from "./processAccidentReport.vue?vue&type=script&lang=js"
export * from "./processAccidentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d81b421')) {
      api.createRecord('3d81b421', component.options)
    } else {
      api.reload('3d81b421', component.options)
    }
    module.hot.accept("./processAccidentReport.vue?vue&type=template&id=3d81b421", function () {
      api.rerender('3d81b421', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/processAccidentReport.vue"
export default component.exports